module.exports = "<div>\n  <h1>{{ $ctrl.name }}</h1>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/category/category.html
// module id = 615
// module chunks = 0